import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const subscribe = (data) => api.post("/subscribe", data).then((r) => r.data);
export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
export const sendChat = (data) => api.post("/chat", data).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const adminGetContacts = (token) => api.get("/contact", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const adminGetSubscribers = (token) => api.get("/subscribe", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
